import moment from 'moment';
import T from 'i18n-react';
import { Typography } from '@material-ui/core';
import React from 'react';

const ComparedToToday = ({ date }: { date: moment.MomentInput }) => {
  let text: string;

  const minutes = moment().diff(moment(date), 'minutes');
  text = `${minutes}${T.translate('user.notification.minutes')}`;

  const hours = moment().diff(moment(date), 'hours');
  if (0 < hours) text = `${hours}${T.translate('user.notification.hours')}`;

  const days = moment().diff(moment(date), 'days');
  if (0 < days) text = `${days}${T.translate('user.notification.days')}`;

  return (
    <Typography color="textSecondary" style={{ fontSize: 14 }}>
      {text}
      {T.translate('user.notification.before')}
    </Typography>
  );
};

export default ComparedToToday;
